import { render, staticRenderFns } from "./TeachersAdm.vue?vue&type=template&id=5b9ab225&scoped=true"
import script from "./TeachersAdm.vue?vue&type=script&lang=js"
export * from "./TeachersAdm.vue?vue&type=script&lang=js"
import style0 from "./TeachersAdm.vue?vue&type=style&index=0&id=5b9ab225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ab225",
  null
  
)

export default component.exports